import { Button, ButtonProps, CircularProgress } from '@mui/material';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import React, { useId } from 'react';
import { useRecoilValue } from 'recoil';
import SEO from 'src/components/Seo';
import { Steps, stepsAtom } from 'src/recoil/steps/atoms';
import {
  StyledCancelButton,
  StyledConditions,
  StyledFooterWrapper,
  StyledHiddenButton,
  StyledLicenseStyle,
  StyledLine,
  StyledLoadingButton,
} from 'src/styles/signup/stepsFooter';

interface StepFooterProps {
  onSubmitProps?: ButtonProps;
  onCancelProps?: ButtonProps;
  next?: boolean;
  submitText?: string;
  hideCancelButton?: boolean;
  hideSubmitButton?: boolean;
  showLicenseConditions?: boolean;
}

const StepFooter: React.FC<StepFooterProps> = ({
  submitText,
  hideCancelButton,
  hideSubmitButton,
  onCancelProps = {},
  onSubmitProps = {},
  showLicenseConditions,
}) => {
  const { t } = useTranslation();
  const { loading, currentStep } = useRecoilValue(stepsAtom);
  const stepTitle = currentStep ? ' - ' + t(currentStep + '.title') : '';

  const backButtonId = useId();
  const nextButtonId = useId();

  const getStableId = (prefix: string) => {
    const stepName = typeof window === 'undefined' ? 'welcome' : currentStep?.toLowerCase() || 'welcome';
    return `${stepName}-${prefix}`;
  };

  const CancelButton = hideCancelButton ? StyledHiddenButton : StyledCancelButton;
  return (
    <>
      <SEO title={t('jonniName') + stepTitle} />
      <StyledLine />
      <StyledFooterWrapper>
        {!hideCancelButton && (
          <CancelButton
            id={`back-button-${backButtonId}`}
            data-testid="cancel-button"
            variant={'outlined'}
            {...onCancelProps}>
            {t('footer.back')}
          </CancelButton>
        )}
        {showLicenseConditions ? <LicenseConditions /> : null}
        {!hideSubmitButton && (
          <StyledLoadingButton
            id={`next-button-${nextButtonId}`}
            data-testid="next-button"
            color="primary"
            disabled={loading}
            variant="contained"
            startIcon={loading ? <CircularProgress size={20} color="inherit" /> : null}
            {...onSubmitProps}>
            {submitText || t('footer.next')}
          </StyledLoadingButton>
        )}
      </StyledFooterWrapper>
    </>
  );
};

const LicenseConditions = () => {
  const { t } = useTranslation();

  return (
    <StyledLicenseStyle>
      <span> {t('footer.register')}</span>
      <a href={`https://www.${process.env.GATSBY_JONNI_DOMAIN}/termsofuse`}>
        <StyledConditions>{t('footer.termsOfUse')}</StyledConditions>
      </a>
      &nbsp;
      <a href={`https://www.${process.env.GATSBY_JONNI_DOMAIN}/privacypolicy`}>
        <StyledConditions>{t('footer.privacyPolicy')}</StyledConditions>
      </a>
    </StyledLicenseStyle>
  );
};

export default StepFooter;
